<template>
  <div v-if="!!phaseData && mounted">
    <v-expansion-panels accordion class="mt-3">
      <v-expansion-panel>
        <v-expansion-panel-header> DOENÇAS CRÔNICAS </v-expansion-panel-header>
        <v-expansion-panel-content>
          <field-label label="Tem alguma doença crônica ou prévia importante?">
            <v-switch
              class="my-2"
              label="Nenhuma comorbidade"
              v-model="phaseData.noDisease"
              hide-details
              @change="onNoDiseasesChange"
            />
            <template v-if="!phaseData.noDisease">
              <div class="d-flex flex-wrap justify-stretch mb-3">
                <div
                  v-for="diseaseOption in diseaseOptions"
                  :key="`disease-${diseaseOption.key}`"
                  class="flex-grow-1 disease-checkbox-wrapper"
                  style="flex-basis: 30%"
                >
                  <v-checkbox
                    dense
                    :label="diseaseOption.name"
                    multiple
                    :value="diseaseOption.key"
                    v-model="phaseData.diseases"
                    @change="checkOther(diseaseOption.key, $event)"
                    hide-details
                    :disabled="diseaseOption.disabled && diseaseOption.disabled(attendance.disease.id)"
                    class="disease-checkbox"
                    :class="{ 'selected-checkbox': phaseData.diseases.includes(diseaseOption.key) }"
                  />
                  <div v-if="phaseData.diseases.includes('hepatite_b') && diseaseOption.key === 'hepatite_b'">
                    <v-col sm="12" md="6" lg="6">
                      <v-text-field
                        label="Carga Viral (cópias/ml)"
                        type="number"
                        outlined
                        v-model="phaseData.diseases_info.hepatite_b.viral_load"
                      />
                    </v-col>
                  </div>
                  <div v-if="phaseData.diseases.includes('hepatite_c') && diseaseOption.key === 'hepatite_c'">
                    <v-col sm="12" md="6" lg="6">
                      <v-text-field
                        label="Carga Viral (cópias/ml)"
                        type="number"
                        outlined
                        v-model="phaseData.diseases_info.hepatite_c.viral_load"
                      />
                    </v-col>
                  </div>
                  <div v-if="phaseData.diseases.includes('hiv') && diseaseOption.key === 'hiv'">
                    <v-row>
                      <v-col sm="12" md="6" lg="6">
                        <v-text-field
                          label="Carga Viral (cópias/ml)"
                          type="number"
                          outlined
                          v-model="phaseData.diseases_info.hiv.viral_load"
                        />
                      </v-col>
                      <v-col sm="12" md="6" lg="6">
                        <v-text-field label="CD4" type="number" outlined v-model="phaseData.diseases_info.hiv.cd4" />
                      </v-col>
                    </v-row>
                  </div>
                </div>
              </div>
              <text-area
                label="Informe outras comorbidades"
                v-show="isOtherDiseaseChecked"
                v-model="phaseData.otherDisease"
                :max-length="500"
                :rows="2"
                class="mb-3"
              />
              <field-label :label="'Outras comorbidades:'">
                <div class="mt-3" />
                <div v-for="diseaseOption in complexDiseaseOptions" :key="`disease-${diseaseOption.key}`">
                  <v-row class="pt-0">
                    <v-col cols="12" class="py-0 pb-3">
                      <v-checkbox
                        dense
                        :value="diseaseOption.key"
                        v-model="phaseData.diseases"
                        :label="diseaseOption.name"
                        hide-details
                        @change="resetObject(diseaseOption.key)"
                      />
                      <div
                        v-if="
                          phaseData.diseases.includes('dermatite_contato') && diseaseOption.key === 'dermatite_contato'
                        "
                      >
                        <text-area
                          :label="'Descreva à que o paciente é sensibilizado'"
                          :max-length="500"
                          :rows="2"
                          v-model="phaseData.diseases_info.dermatite_contato.sensibility"
                          class="mt-3 ml-3"
                        />
                      </div>
                      <div v-else-if="phaseData.diseases.includes('alergias') && diseaseOption.key === 'alergias'">
                        <div class="d-flex ml-3 flex-column flex-md-row">
                          <v-checkbox
                            v-for="option in diseaseOption.options"
                            :key="option.key"
                            :value="option.key"
                            :label="option.name"
                            v-model="phaseData.diseases_info.alergias.selected"
                            dense
                            class="pr-3 pt-0 mt-3"
                            @change="resetTextField"
                          />
                        </div>
                        <text-area
                          v-model="phaseData.diseases_info.alergias.description"
                          :label="'Descreva à que o paciente é alérgico'"
                          :max-length="500"
                          :rows="2"
                        />
                      </div>
                      <div v-else-if="phaseData.diseases.includes('neoplasia') && diseaseOption.key === 'neoplasia'">
                        <v-row class="mt-3 ml-3">
                          <v-col sm="12" md="6" lg="6">
                            <v-text-field
                              label="Tratamento"
                              outlined
                              v-model="phaseData.diseases_info.neoplasia.treatment"
                            />
                          </v-col>
                          <v-col sm="12" md="3" lg="3">
                            <v-menu
                              ref="pickStartDate"
                              v-model="pickStartDate"
                              :close-on-content-click="false"
                              transition="scale-transition"
                              offset-y
                              max-width="290px"
                              min-width="auto"
                            >
                              <template v-slot:activator="{ on, attrs }">
                                <v-text-field
                                  :value="
                                    phaseData.diseases_info.neoplasia.start
                                      ? $moment(phaseData.diseases_info.neoplasia.start).format('DD/MM/YYYY')
                                      : 'Data inicial'
                                  "
                                  outlined
                                  label="Data inicial"
                                  v-bind="attrs"
                                  v-on="on"
                                />
                              </template>
                              <v-date-picker
                                v-model="phaseData.diseases_info.neoplasia.start"
                                no-title
                                @change="pickStartDate = false"
                                locale="pt-br"
                              ></v-date-picker>
                            </v-menu>
                          </v-col>
                          <v-col sm="12" md="3" lg="3">
                            <v-menu
                              ref="pickEndDate"
                              v-model="pickEndDate"
                              :close-on-content-click="false"
                              transition="scale-transition"
                              offset-y
                              max-width="290px"
                              min-width="auto"
                            >
                              <template v-slot:activator="{ on, attrs }">
                                <v-text-field
                                  :value="
                                    phaseData.diseases_info.neoplasia.end
                                      ? $moment(phaseData.diseases_info.neoplasia.end).format('DD/MM/YYYY')
                                      : 'Data final'
                                  "
                                  outlined
                                  label="Data final"
                                  v-bind="attrs"
                                  v-on="on"
                                />
                              </template>
                              <v-date-picker
                                v-model="phaseData.diseases_info.neoplasia.end"
                                no-title
                                @change="pickEndDate = false"
                                locale="pt-br"
                              ></v-date-picker>
                            </v-menu>
                          </v-col>
                        </v-row>
                      </div>
                      <div
                        v-else-if="
                          phaseData.diseases.includes('herpes_simples') && diseaseOption.key === 'herpes_simples'
                        "
                      >
                        <v-row class="mt-3 ml-3">
                          <v-col sm="12" md="5" lg="5">
                            <v-text-field
                              outlined
                              label="Quantas vezes por ano?"
                              v-model="phaseData.diseases_info.herpes_simples.times_per_year"
                              type="number"
                            />
                          </v-col>
                        </v-row>
                      </div>
                      <div
                        v-else-if="
                          phaseData.diseases.includes('erupcao_variceliforme_kaposi') &&
                          diseaseOption.key === 'erupcao_variceliforme_kaposi'
                        "
                      >
                        <v-row class="mt-3 ml-3">
                          <v-col sm="12" md="5" lg="5">
                            <v-text-field
                              outlined
                              label="Quantas vezes?"
                              v-model="phaseData.diseases_info.erupcao_variceliforme_kaposi.times"
                              type="number"
                            />
                          </v-col>
                        </v-row>
                      </div>
                    </v-col>
                  </v-row>
                </div>
              </field-label>
            </template>
          </field-label>

          <div v-for="chronicDiseaseOption in chronicDiseaseOptions" :key="chronicDiseaseOption.key" class="mt-3">
            <radio-options
              :label="chronicDiseaseOption.name"
              v-model="phaseData.profile[chronicDiseaseOption.key].value"
              row
              clearable
              :options="chronicDiseaseOption.options || defaultProfileOptions"
              @change="checkProfile(chronicDiseaseOption.key, $event)"
              :disabled="chronicDiseaseOption.disabled && chronicDiseaseOption.disabled(attendance.disease.id)"
              :subtitle="
                getSubtitle(chronicDiseaseOption.disabled && chronicDiseaseOption.disabled(attendance.disease.id))
              "
              :rules="chronicDiseaseOption?.required ? [$validation.radioRequired()] : []"
              :required="chronicDiseaseOption.required"
            />
          </div>

          <text-area
            class="mt-4 mb-8"
            label="Quais medicamentos usa?"
            v-model="phaseData.medicine"
            :max-length="500"
            :rows="2"
          />
        </v-expansion-panel-content>
      </v-expansion-panel>
      <!-- =========================================================================================================== -->
      <v-expansion-panel v-if="attendance.disease.id == disease.ATOPIC_DERMATITIS && !attendance.data.summarizedFlow">
        <v-expansion-panel-header> HÁBITOS </v-expansion-panel-header>
        <v-expansion-panel-content>
          <div v-for="habitsOption in habitsOptions" :key="habitsOption.key">
            <radio-options
              class="mb-2"
              :label="habitsOption.name"
              v-model="phaseData.profile[habitsOption.key].value"
              row
              clearable
              :options="habitsOption.options || defaultProfileOptions"
              @change="checkProfile(habitsOption.key, $event)"
              :disabled="habitsOption.disabled && habitsOption.disabled(attendance.disease.id)"
              :subtitle="getSubtitle(habitsOption.disabled && habitsOption.disabled(attendance.disease.id))"
              :rules="habitsOption?.required ? [$validation.radioRequired()] : []"
              :required="habitsOption.required"
            />
          </div>
        </v-expansion-panel-content>
      </v-expansion-panel>
      <v-expansion-panel>
        <!-- =========================================================================================================== -->
        <v-expansion-panel-header> TUBERCULOSE </v-expansion-panel-header>
        <v-expansion-panel-content>
          <div v-for="profileOption in profileOptions" :key="profileOption.key">
            <radio-options
              class="mb-2"
              v-show="profileOption.key !== 'tipo_cancer_pele' || phaseData.profile['cancer_pele'].value"
              :label="profileOption.name"
              v-model="phaseData.profile[profileOption.key].value"
              row
              clearable
              :options="profileOption.options || defaultProfileOptions"
              @change="checkProfile(profileOption.key, $event)"
              :disabled="profileOption.disabled && profileOption.disabled(attendance.disease.id)"
              :subtitle="getSubtitle(profileOption.disabled && profileOption.disabled(attendance.disease.id))"
              :rules="profileOption?.required ? [$validation.radioRequired()] : []"
              :required="profileOption.required"
            />
            <div
              v-if="phaseData?.profile[profileOption.key]?.value != 'NÃO' && profileOption?.key === 'tuberculose'"
              class="ml-3"
            >
              <v-row>
                <div class="col-sm-5 col-md-12 col-lg-5 col">
                  <v-menu
                    ref="pickTuberculoseDate"
                    v-model="pickTuberculoseDate"
                    :close-on-content-click="false"
                    transition="scale-transition"
                    offset-y
                    max-width="290px"
                    min-width="auto"
                    :required="profileOption.required"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        :value="
                          phaseData.diseases_info.neoplasia.end
                            ? $moment(phaseData.diseases_info.neoplasia.end).format('DD/MM/YYYY')
                            : ''
                        "
                        outlined
                        label="Qual a data do diagnóstico?"
                        v-bind="attrs"
                        v-on="on"
                      />
                    </template>
                    <v-date-picker
                      v-model="phaseData.diseases_info.neoplasia.end"
                      no-title
                      @change="pickTuberculoseDate = false"
                      locale="pt-br"
                    ></v-date-picker>
                  </v-menu>
                </div>
              </v-row>
            </div>
          </div>
        </v-expansion-panel-content>
      </v-expansion-panel>
      <!-- =========================================================================================================== -->
      <v-expansion-panel v-if="attendance.patient.assignedSex !== 'M'">
        <v-expansion-panel-header> GINECOLÓGICOS E OBSTÉTRICOS </v-expansion-panel-header>
        <v-expansion-panel-content>
          <div v-for="obstetricOption in obstetricOptions" :key="obstetricOption.key">
            <radio-options
              class="mb-2"
              :label="obstetricOption.name"
              v-model="phaseData.profile[obstetricOption.key].value"
              row
              clearable
              :options="obstetricOption.options || defaultProfileOptions"
              @change="checkProfile(obstetricOption.key, $event)"
              :disabled="obstetricOption.disabled && obstetricOption.disabled(attendance.disease.id)"
              :subtitle="getSubtitle(obstetricOption.disabled && obstetricOption.disabled(attendance.disease.id))"
              :rules="obstetricOption?.required ? [$validation.radioRequired()] : []"
              :required="obstetricOption.required"
            />
          </div>
          <field-label :label="'Contracepção?'">
            <v-row>
              <v-col cols="6" class="mt-3 py-0 pb-3">
                <div
                  v-for="contracepcaoOption in contracepcaoOptions"
                  :key="contracepcaoOption.key"
                  class="d-flex flex-column"
                >
                  <v-checkbox
                    :label="contracepcaoOption.name"
                    :value="contracepcaoOption.key"
                    v-model="phaseData.profile_info.contracepcao.selected"
                    hide-details
                    dense
                  />
                </div>
              </v-col>
            </v-row>
          </field-label>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
    <field-label class="mt-8" label="Anotações">
      <text-area :readonly="disabled" :max-length="2000" v-model="phaseData.notes" />
    </field-label>
  </div>
</template>
<script>
import { createNamespacedHelpers } from 'vuex'

import {
  COMORBIDITIES_OPTIONS,
  COMPLEX_COMORBIDITIES_OPTIONS,
  CONTRACEPCAO,
  PERSONAL_HISTORY_CHRONIC_DISEASES_OPTIONS,
  PERSONAL_HISTORY_HABITS_OPTIONS,
  PERSONAL_HISTORY_OBSTETRIC_OPTIONS,
  PERSONAL_HISTORY_PROFILE_OPTIONS,
  PERSONAL_HISTORY_PROFILE_SUMMARIZED_OPTIONS_DA,
} from '@/components/AttendanceForm/general/constants/personalHistory'
import FieldLabel from '@/components/FieldLabel.vue'
import RadioOptions from '@/components/RadioOptions.vue'
import TextArea from '@/components/TextArea.vue'
import { DISEASES } from '@/constants/disease'
import BasePhase from './BasePhase.vue'

const { mapGetters: attendanceGettersMap } = createNamespacedHelpers('attendance')

export default {
  components: { FieldLabel, TextArea, RadioOptions },
  extends: BasePhase,
  computed: {
    ...attendanceGettersMap(['attendanceDiseaseId']),
    ...attendanceGettersMap(['getPhaseDataByKey', 'attendance']),
    diseaseOptions() {
      return COMORBIDITIES_OPTIONS.sort(function (a, b) {
        if (a.key === 'outras_comorbidades') return 1
        if (a.name < b.name) return -1
        if (a.name > b.name) return 1
        return 0
      })
    },
    complexDiseaseOptions() {
      return COMPLEX_COMORBIDITIES_OPTIONS.sort(function (a, b) {
        if (a.key === 'outras_comorbidades') return 1
        if (a.name < b.name) return -1
        if (a.name > b.name) return 1
        return 0
      })
    },
    isOtherDiseaseChecked() {
      return this.phaseData && this.phaseData.diseases && this.phaseData.diseases.includes('outras_comorbidades')
    },
    defaultProfileOptions() {
      return [
        { text: 'Sim', value: true },
        { text: 'Não', value: false },
      ]
    },
    symptomsPhaseData() {
      return this.getPhaseDataByKey('sintomas')
    },
    profileOptions() {
      let personalHistory = PERSONAL_HISTORY_PROFILE_OPTIONS.filter(
        (option) => !this.attendance.data.summarizedFlow || option.required,
      )

      if (this.attendanceDiseaseId === DISEASES.ATOPIC_DERMATITIS && this.attendance.data.summarizedFlow) {
        personalHistory = PERSONAL_HISTORY_PROFILE_SUMMARIZED_OPTIONS_DA
      }
      const filteredOptions =
        this.attendance.patient.assignedSex === 'M'
          ? personalHistory.filter((option) => option.key !== 'gravidez')
          : personalHistory

      return filteredOptions
    },
  },
  data() {
    return {
      pickTuberculoseDate: false,
      pickStartDate: false,
      pickEndDate: false,
      mounted: false,
      habitsOptions: PERSONAL_HISTORY_HABITS_OPTIONS,
      obstetricOptions: PERSONAL_HISTORY_OBSTETRIC_OPTIONS,
      chronicDiseaseOptions: PERSONAL_HISTORY_CHRONIC_DISEASES_OPTIONS,
      contracepcaoOptions: CONTRACEPCAO,
      disease: DISEASES,
    }
  },
  methods: {
    getDefaultData() {
      const data = {
        noDisease: false,
        otherDisease: null,
        diseases: this.buildDiseasesArray(),
        diseases_info: this.buildDiseaseInfo(),
        medicine: null,
        profile: this.buildEmptyProfile(),
        profile_info: this.buildProfileInfo(),
        notes: null,
      }
      return data
    },
    buildDiseasesArray() {
      return this.symptomsPhaseData?.symptoms?.alteracao_habito_intestinal?.value
        ? ['doenca_inflamatoria_intestinal']
        : []
    },
    buildDiseaseInfo() {
      return {
        hepatite_b: {
          viral_load: null,
        },
        hepatite_c: {
          viral_load: null,
        },
        hiv: {
          viral_load: null,
          cd4: null,
        },
        dermatite_contato: {
          sensibility: null,
        },
        alergias: {
          selected: [],
          description: null,
        },
        neoplasia: {
          treatment: null,
          start: null,
          end: null,
        },
        herpes_simples: {
          times_per_year: null,
        },
        erupcao_variceliforme_kaposi: {
          times: null,
        },
      }
    },
    buildEmptyProfile() {
      return [
        ...PERSONAL_HISTORY_PROFILE_OPTIONS,
        ...PERSONAL_HISTORY_CHRONIC_DISEASES_OPTIONS,
        ...PERSONAL_HISTORY_HABITS_OPTIONS,
        ...PERSONAL_HISTORY_OBSTETRIC_OPTIONS,
      ].reduce((acc, option) => {
        let value = null

        if (option.key === 'uveite') {
          value = this.symptomsPhaseData?.symptoms?.uveite?.value
        }
        if (option.key === 'diarreia_cronica') {
          value = this.symptomsPhaseData?.symptoms?.alteracao_habito_intestinal?.value
        }

        return { ...acc, [option.key]: { value } }
      }, {})
    },
    buildProfileInfo() {
      return {
        tuberculose: {
          diagnosis: null,
          treatment: {
            year: null,
            months: null,
            treatments: [],
            other: null,
          },
        },
        menarca: {
          age: null,
        },
        contracepcao: {
          selected: [],
          other: null,
        },
      }
    },
    onNoDiseasesChange() {
      this.phaseData.diseases = []
      this.phaseData.otherDisease = null
    },
    checkOther(key, value) {
      if (key === 'outras_comorbidades' && !value.includes('outras_comorbidades')) {
        this.phaseData.otherDisease = null
      }
    },
    checkProfile(key, value) {
      if (key === 'cancer_pele' && !value) {
        this.phaseData.profile['tipo_cancer_pele'].value = null
      }
    },
    getSubtitle(showSub) {
      if (!showSub) {
        return null
      }
      return 'Essa opção já foi preenchida em Anamnese - Sintomas'
    },
    resetObject(key) {
      if (!this.phaseData.diseases.includes(key)) {
        for (let param in this.phaseData.diseases_info[key]) {
          Array.isArray(this.phaseData.diseases_info[key][param])
            ? (this.phaseData.diseases_info[key][param] = [])
            : (this.phaseData.diseases_info[key][param] = null)
        }
      }
    },
    resetTextField() {
      if (!this.phaseData.diseases_info.alergias.selected.includes('outro')) {
        this.phaseData.diseases_info.alergias.other = null
      }
    },
  },
  mounted() {
    const keys = ['tratou_tuberculose', 'tuberculose', 'etilista', 'tabagista']
    keys.forEach((key) => {
      if (typeof this.phaseData.profile[key]?.value == 'boolean') {
        this.phaseData.profile[key].value = this.phaseData.profile[key].value ? 'SIM' : 'NÃO'
      }
    })

    if (!this.phaseData.diseases_info) this.phaseData.diseases_info = this.buildDiseaseInfo()
    if (!this.phaseData.profile_info) this.phaseData.profile_info = this.buildProfileInfo()
    this.phaseData.profile = { ...this.buildEmptyProfile(), ...this.phaseData.profile }
    this.mounted = true
  },
}
</script>

<style scoped>
.disease-checkbox {
  padding: 12px;
  margin: 8px;
  height: 100%;
  align-content: center;
  border-radius: 10px;
}
.selected-checkbox {
  border: 2px solid #1976d2;
}
.disease-checkbox-wrapper {
  margin: 12px;
  padding: 12px;
  border: 2px solid #33333330;
  height: 100%;
  align-content: center;
  border-radius: 10px;
}
:deep(.v-input--selection-controls.v-input) {
  align-items: center;
}
:deep(.v-application--is-ltr .v-input--selection-controls__input) {
  align-self: flex-start;
}
</style>
